"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _Table = _interopRequireDefault(require("./Table"));
var _base = require("../Icons/components/base");
var _excluded = ["isSorted", "isDesc", "automationHook"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /** Weather or not the column has sorting applied */
  isSorted: _propTypes["default"].bool,
  /** Weather column is sorted descending or ascending */
  isDesc: _propTypes["default"].bool,
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string
};
var SortIcon = function SortIcon(_ref) {
  var isSorted = _ref.isSorted,
    isDesc = _ref.isDesc,
    automationHook = _ref.automationHook,
    other = _objectWithoutProperties(_ref, _excluded);
  var SortedIcon = isDesc ? _base.SortUp2 : _base.SortDown2;
  return /*#__PURE__*/_react["default"].createElement(_Table["default"].IconContainer, _extends({}, (0, _automationHooks.hook)(automationHook, "".concat(!isSorted ? "unsorted" : isDesc ? "sorted-desc" : "sorted-asc")), other), isSorted ? /*#__PURE__*/_react["default"].createElement(SortedIcon, {
    color: "focus",
    size: "s"
  }) : /*#__PURE__*/_react["default"].createElement(_base.Unsorted, {
    color: "textSecondary",
    size: "s"
  }));
};
SortIcon.propTypes = propTypes;
var _default = SortIcon;
exports["default"] = _default;